import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

function PuzzleBoard() {
  const [gridItems, setGridItems] = useState([]);
  const [time, setTime] = useState({ ms: 0, s: 0, m: 0 });
  const [interv, setInterv] = useState();
  const inputRefs = useRef([]);

  useEffect(() => {
    const missingIndices = new Set();
    while (missingIndices.size < 5) {
      missingIndices.add(Math.floor(Math.random() * 10));
    }
    const numbers = Array.from({ length: 10 }, (_, i) =>
      missingIndices.has(i) ? '' : String(i)
    );
    
    setGridItems(numbers);

    startTimer();
    clearInterval(interv);
    inputRefs.current = Array(26).fill().map((_, i) => inputRefs.current[i] || null);
    inputRefs.current[0]?.focus(); // Focus on the first input field
  }, []);

  const handleReset = () => {
    const missingIndices = new Set();
    while (missingIndices.size < 5) {
      missingIndices.add(Math.floor(Math.random() * 10));
    }
    const numbers = Array.from({ length: 10 }, (_, i) =>
      missingIndices.has(i) ? '' : String(i)
    );
    
    setGridItems(numbers);

    resetTimer();
    inputRefs.current = Array(10).fill().map((_, i) => inputRefs.current[i] || null);
    inputRefs.current[0]?.focus(); // Focus on the first input field
  };

  const renderGrid = () => {
    return gridItems.map((item, index) => (
      <input
        key={index}
        ref={(ref) => (inputRefs.current[index] = ref)}
        type="text"
        className="font-bold text-center text-[#ffffff] bg-[#FF008A] border-solid border-[5px] border-[#276ED8] p-2 m-1 text-3xl flex justify-center items-center rounded cursor-pointer w-[70px] h-[70px]"
        value={item}
        onChange={(e) => handleInputChange(index, e.target.value)}
      />
    ));
  };

  const handleInputChange = (index, value) => {
    const newValue = value.toUpperCase();
    if (newValue === String(index)) {
      const newGridItems = [...gridItems];
      newGridItems[index] = newValue;
      setGridItems(newGridItems);
  
      // Find the index of the next empty grid element
      const nextIndex = newGridItems.findIndex((item) => item === '');
      if (nextIndex !== -1) {
        inputRefs.current[nextIndex]?.focus();
      }
  
      if (nextIndex !== -1) {
        inputRefs.current[nextIndex]?.focus();
      } else {
        toast.success("🦄 Won");
      }
    } else {
      toast.error('Thats wrong', {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        });
    }
  };
  

  const startTimer = () => {
    setInterv(setInterval(runTimer, 10));
  };

  const runTimer = () => {
    setTime((prevTime) => {
      let updatedMS = prevTime.ms + 1,
        updatedS = prevTime.s,
        updatedM = prevTime.m;
      if (updatedMS === 100) {
        updatedS++;
        updatedMS = 0;
      }
      if (updatedS === 60) {
        updatedM++;
        updatedS = 0;
      }
      return { ms: updatedMS, s: updatedS, m: updatedM };
    });
  };

  const resetTimer = () => {
    clearInterval(interv); // Clear the interval
    setTime({ ms: 0, s: 0, m: 0 }); // Reset time
    startTimer();
  };

  const rainbowBgClass = false ? 'rainbow-bg' : ''; // Add rainbow background class conditionally

  return (
    <>
      <div className={`flex flex-col justify-center items-center h-screen bg-[#111624] ${rainbowBgClass}`}>
        <div className="bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2">
          <div className="mx-2">
            <h1>{time.m >= 10 ? time.m : '0' + time.m}</h1>
          </div>
          <p>:</p>
          <div className="mx-2">
            <h1>{time.s >= 10 ? time.s : '0' + time.s}</h1>
          </div>
          <p>:</p>
          <div className="mx-2">
            <h1>{time.ms >= 10 ? time.ms : '0' + time.ms}</h1>
          </div>
        </div>
        <div className="grid grid-cols-3 grid-rows-4">{renderGrid()}</div>

        <button
          className="bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2"
          onClick={handleReset}
        >
          Reset
        </button>

        <Link
          to="/"
          className="bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2"
        >
          Home
        </Link>
      </div>
    </>
  );
}

export default PuzzleBoard;
